import { SearchAggsInput } from "@examspark/types";

import { Params } from ".";

export const bulkSearch = (params?: Params) => /* GraphQL */ `
query ${params?.label || "BulkSearch"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
) {
  bulkSearch(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
  ) {
    items
    nextToken
    total
    __typename
  }
}
`;

export const search = (params?: Params) => /* GraphQL */ `
query ${params?.label || "Search"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
  $authorizationContext: AuthorizationContextInput
) {
  search(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
    authorizationContext: $authorizationContext
  ) {
    items {
      ${params?.fields ?? ` id sk name idInc createdAt updatedAt isArchived `}
    }
    aggregations
    nextToken
    total
    __typename
  }
}
`;

export const adminSearch = (params?: Params) => /* GraphQL */ `
query ${params?.label || "AdminSearch"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
) {
  adminSearch(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ${params?.fields ?? ` id sk name idInc idVendor createdAt updatedAt workspaceId tags { key type value }`}
    }
    aggregations
    nextToken
    total
    __typename
  }
}
`;

export const searchExamResponses = (params?: Params) => /* GraphQL */ `
query ${params?.label || "SearchExamResponses"}(
  $filter: SearchableResourceFilterInput
  $sort: [SearchableResourceSortInput!]
  $aggsNew: [SearchAggsInput!]
  $limit: Int
  $nextToken: String
) {
  searchExamResponses(
    filter: $filter
    sort: $sort
    aggsNew: $aggsNew
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ${params?.fields ?? ` id sk name idInc createdAt updatedAt `}
    }
    aggregations
    nextToken
    total
    __typename
  }
}
`;

export const buildReferencesAggregation = (sk: string): SearchAggsInput[] => {
  return [
    {
      name: "references",
      type: "nested",
      path: "referencesIds",
      aggs: [
        {
          name: "sk",
          type: "filter",
          query: JSON.stringify({
            term: {
              "referencesIds.sk.keyword": sk,
            },
          }),
          aggs: [
            {
              name: "id",
              type: "terms",
              field: "referencesIds.id",
            },
          ],
        },
      ],
    },
  ];
};
